import { Flex } from "@radix-ui/themes";
import { useState } from "react";

import { GeneralInfoSection } from "./general-info-section";
import { GondolaChangeGroupsList } from "./gondola-change-groups-list";
import { GondolaChangesList } from "./gondola-changes-list";
import { SkuSectionChangeGroupTable } from "./sku-section-change-group-table";

export function LeftSidebar({
  isLoadingOrderInspection,
}: {
  isLoadingOrderInspection: boolean;
}) {
  const [isTableExpanded, setIsTableExpanded] = useState(false);

  return (
    <Flex direction="column" maxHeight="100%" height="100%">
      <Flex
        direction="column"
        flexShrink={isTableExpanded ? "1" : "0"}
        className={isTableExpanded ? "h-0 overflow-hidden" : "h-auto"}
      >
        <GeneralInfoSection
          isLoadingOrderInspection={isLoadingOrderInspection}
        />
      </Flex>
      <Flex
        direction="column"
        flexGrow={isTableExpanded ? "0" : "1"}
        minHeight="0"
        className={isTableExpanded ? "h-0 overflow-hidden" : "flex-1"}
      >
        <GondolaChangeGroupsList />
        <GondolaChangesList />
      </Flex>
      <SkuSectionChangeGroupTable
        isExpanded={isTableExpanded}
        onToggleExpanded={() => setIsTableExpanded(!isTableExpanded)}
      />
    </Flex>
  );
}
